import { useStaticQuery, graphql } from "gatsby"

const useSunnysideProductQuery = () => {
  const { allDatoCmsSunnysideProduct } = useStaticQuery(graphql`
    query SunnysideProducts {
      allDatoCmsSunnysideProduct(
        filter: {
          hideForLocale: {ne: true}
          hideFromArchive: {ne: true}
        },
        sort: {position: ASC}
      ) {
        nodes {
          id
          originalId
          displayAllSizesInArchive
          title
          brand
          slug
          permalink
          header
          size
          availableIn {
            label
            url {
              ... on DatoCmsEdlynProduct {
                id
                title
                permalink
              }
              ... on DatoCmsBoneProduct {
                id
                title
                permalink
              }
              ... on DatoCmsWoodsProduct {
                id
                title
                permalink
              }
              ... on DatoCmsGreenwheatProduct {
                id
                title
                permalink
              }
              ... on DatoCmsSunnysideProduct {
                id
                title
                permalink
              }
            }
          }
          category: sunnysideProductCategories {
            title
          }
          gallery {
            ...InternalAssetProps
          }
        }
      }
    }
  `)
  return allDatoCmsSunnysideProduct.nodes
}

export default useSunnysideProductQuery